import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useEffect } from "react";

import {
  checkFollowedCities,
  unfollowCity,
  followCity,
  showAppModal,
} from "redux/actions/app";
import { Modal } from "antd";

const CityJoinBtn = ({
  large,
  city,
  token,
  followedCities,
  checkFollowedCities,
  unfollowCity,
  followCity,
  showAppModal,
  refresh,
}: any) => {
  const refreshData = () => {
    checkFollowedCities(token);
    refresh && refresh();
  };

  return (
    <>
      {followedCities &&
      followedCities.length > 0 &&
      followedCities.includes(city.id) ? (
        <div
          className={`${
            large ? "join-btn-big joined-big" : "join-btn joined "
          }`}
          onClick={() => {
            Modal.confirm({
              title: "确认退出城市吗？",
              content: "退出后你可能会错过该城市下的精彩帖子和活动哦",
              onOk() {
                unfollowCity(token, city.id, () => {
                  refreshData();
                });
              },
            });
          }}
        >
          已加入
        </div>
      ) : (
        <div
          className={`${large ? "join-btn-big" : "join-btn"}`}
          onClick={() => {
            if (token) {
              followCity(token, city.id, () => {
                refreshData();
              });
            } else {
              showAppModal("PhoneSigninModal");
            }
          }}
        >
          加入该城市
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  token: state.user.token,
  followedCities: state.app.followedCities,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    { checkFollowedCities, showAppModal, unfollowCity, followCity },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(CityJoinBtn);
